import { Component } from '@angular/core';

import { AutoUnsubscribe, IdentityService } from '../../services';
import { AppService } from '../../services/app.service';

import { Tile, User } from '../../models'

@Component({
    selector: 'home',
    template: require('./home.html'),
    styles: [require('./home.css')],
})

@AutoUnsubscribe()
export class HomeView {
    private subscriptions: any[] = [];
    private me: User;
    protected tiles: Tile[] = [];

    constructor(private identity: IdentityService, private app: AppService) { }

    ngOnInit() {
        this.subscriptions.push(this.identity.me$.subscribe((me: User) => {
            this.me = me;
            this.getTiles();
        }));

        this.me = this.identity.me;
        if (this.me)
            this.getTiles();
    }

    private getTiles() {
        this.tiles = this.app.appLookup(this.me.apps);
    }

}